import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../App';
import { useLanguage } from '../contexts/LanguageContext';
import { Sparkle } from '@phosphor-icons/react';

/**
 * Bandeau affiché en haut de l'app quand l'utilisateur est sur le compte
 * DÉMO public (« Essayer sans inscription »). CTA : créer un vrai compte.
 */
export const DemoBanner = () => {
  const { user, logout } = useContext(AuthContext) || {};
  const { t } = useLanguage();
  const navigate = useNavigate();

  if (!user?.is_demo) return null;

  const goRegister = () => {
    if (logout) logout();
    navigate('/auth');
  };

  return (
    <div
      data-testid="demo-banner"
      className="sticky top-0 z-50 flex items-center justify-center gap-3 bg-emerald-700 text-white px-4 py-2 text-sm"
    >
      <Sparkle size={16} weight="fill" className="shrink-0" />
      <span className="font-semibold">{t('landing.demoBannerText')}</span>
      <button
        type="button"
        data-testid="demo-banner-register-btn"
        onClick={goRegister}
        className="px-3 py-1 rounded-full bg-white text-emerald-800 text-xs font-bold hover:bg-emerald-50 transition-colors"
      >
        {t('landing.demoBannerCta')}
      </button>
    </div>
  );
};

export default DemoBanner;
